import React from 'react';
import { withRouter } from 'react-router-dom';
import { words } from 'lodash';
import Dotdotdot from 'react-dotdotdot';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import Marker from 'assets/images/marker.png';
// eslint-disable-next-line
import styles from "./styles.scss";

const CareerDetailsBanner = props => {
  const { height, isMobile } = useViewport();
  const {
    name,
    city,
    country,
    distance,
    jobShortDescription,
    listImageUrl,
    listMobileImageUrl,
    thumbNailUrl,
    thumbNailMobile,
    jobShortMobileDescription,
    roleMobileShortDescription,
    banner_video,
  } = props.data.specificJobData;

  let description = StringUtil.sliceHtml(jobShortDescription);
  let mobileDescription = StringUtil.sliceHtml(roleMobileShortDescription);
  description = `${StringUtil.formatDescription(description, 11)}...`;
  const length = words(description).length;

  let className = 'career-details-banner';
  let thumbNail = thumbNailUrl;
  let imageUrl = listImageUrl;
  if (isMobile) {
    imageUrl = listMobileImageUrl;
    thumbNail = thumbNailMobile;
  }

  const renderDescription = () => {
    return (
      <HTMLView
        className={'career-detail-description'}
        html={jobShortDescription}
        tagName={'div'}
      />
    );
  };

  const renderInfo = () => {
    return (
      <div className={'post-summary'}>
        <div className={'post-timeline'}>{`POSTED${' '}${distance}`}</div>
        <div className={'card-description'}>
          <Dotdotdot clamp={1}>{mobileDescription}</Dotdotdot>
        </div>
      </div>
    );
  };

  const renderCard = () => {
    return (
      <div className={'career-banner-card'}>
        <div className={'inner-content'}>
          <div className={'location-container'}>
            <div className={'location-marker'}>
              <img src={Marker} alt={'location'} />
            </div>
            <span className={'address'}>{city + `, ` + country}</span>
          </div>
          {renderInfo()}
        </div>
      </div>
    );
  };

  const renderBannerDescription = () => {
    return (
      <Dotdotdot clamp={1} tagName={'div'}>
        <HTMLView html={jobShortMobileDescription} tagName={'p'} />
      </Dotdotdot>
    );
  };

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        title={name}
        length={length}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        titleHeading={isMobile ? renderBannerDescription() : null}
        containerClassName={'intro'}
        description={renderDescription()}
        descriptionClass={'career-description'}
      />
      {isMobile && renderCard()}
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
    </div>
  );
};

export default withRouter(CareerDetailsBanner);
